import { render, staticRenderFns } from "./submit-branded-caller-id-dialog.vue?vue&type=template&id=0f848d46&scoped=true"
import script from "./submit-branded-caller-id-dialog.vue?vue&type=script&lang=js"
export * from "./submit-branded-caller-id-dialog.vue?vue&type=script&lang=js"
import style0 from "./submit-branded-caller-id-dialog.vue?vue&type=style&index=0&id=0f848d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f848d46",
  null
  
)

export default component.exports